import * as React from "react";

import { PICField } from "components/Form/Fields/PICField";

interface PropertyFieldProps {
  disabled?: boolean;
  name: string;
  label: string;
}

// This field isn't scoped to a business, so it uses showAllProperties for a system-wide,
// searchable property list. With no businessId, PICField's "add new PIC" path always shows
// a "select a business first" error, so this is a picker over existing properties only.
export const PropertySelectField = ({
  disabled = false,
  name,
  label,
}: PropertyFieldProps) => (
  <PICField
    buyerWayName={undefined}
    businessId={undefined}
    suggestedValueFieldName={undefined}
    staticOptionLabel={undefined}
    name={name}
    label={label}
    disabled={disabled}
    showAllProperties
  />
);
